import React from 'react';
import { PsListTable } from '../../shared/components/list-table/PsListTable';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { PsMoreMenu } from '../../shared/components/more-menu/PsMoreMenu';
import PropTypes from 'prop-types';
import ConfirmModal from '../../shared/components/confirm-modal/ConfirmModal';
import { DeleteContractorFileTask } from './webservices/delete-documentary-library/DeleteContractorFileTask';
import { DeleteContractorFileRequest } from './webservices/delete-documentary-library/DeleteContractorFileRequest';
import Alert from 'react-s-alert';

export class DocumentaryLibraryTable extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showDeleteConfirmModal: false,
            selectedContractorFileId: null,
        };
    }

    handleDeleteContractorFile = (selectedContractorFileId) => {
        this.setState({
            showDeleteConfirmModal: true,
            selectedContractorFileId,
        });
    };

    render() {
        const {
            data,
            error,
            loading,
            canDelete,
        } = this.props;

        return (
            <PsListTable
                data={data}
                error={error}
                loading={loading}
                headings={(
                    <tr>
                        <th>{I18nUtils.tr('TR_FECHA')}</th>
                        <th>{I18nUtils.tr('TR_NOMBRE')}</th>
                        <th>{I18nUtils.tr('TR_CONTRATA')}</th>
                        <th/>
                    </tr>
                )}
            >
                {
                    data.map(contractorFile => {
                        const contractorFileId = contractorFile.id();
                        const options = [
                            {
                                label: I18nUtils.tr('TR_DOWNLOAD'),
                                openNewWindow: true,
                                route: { pathname: contractorFile.file() },
                            },
                        ];
                        if ( canDelete && contractorFile.canDelete() ) {
                            options.push(
                                {
                                    label: I18nUtils.tr('TR_ELIMINAR'),
                                    click: () => this.handleDeleteContractorFile(contractorFileId),
                                },
                            );
                        }

                        return (
                            <tr key={contractorFileId}>
                                <td>{contractorFile.date()}</td>
                                <td>{contractorFile.name()}</td>
                                <td>{contractorFile.contractorName()}</td>
                                <td><PsMoreMenu options={options}/></td>
                            </tr>
                        );
                    })
                }
                {this.renderConfirmModal()}
            </PsListTable>
        );
    }

    renderConfirmModal() {
        const { showDeleteConfirmModal } = this.state;

        return (
            <ConfirmModal
                show={showDeleteConfirmModal}
                onHide={() => this.setState({ showDeleteConfirmModal: false })}
                onAccept={this.deleteContractorFile}
                title={I18nUtils.tr('TR_ELIMINAR_DOCUMENTO')}
                bodyTitle={I18nUtils.tr('TR_ESTAS_A_PUNTO_DE_ELIMINAR_ESTE_DOCUMENTO')}
                bodyText={`${I18nUtils.tr('TR_ESTAS_A_PUNTO_DE_ELIMINAR_ESTE_DOCUMENTO')} ${I18nUtils.tr('TR_DESEAS_CONTINUAR')}`}
            />
        );
    }

    deleteContractorFile = () => {
        const {
            cleanFiltersHandler,
            refreshListHandler,
        } = this.props;
        const { selectedContractorFileId } = this.state;

        const request = new DeleteContractorFileRequest({ id: selectedContractorFileId });

        new DeleteContractorFileTask(request)
            .onSuccess(() => {
                Alert.success(I18nUtils.tr('TR_DOCUMENTO_ELIMINADO_CORRECTAMENTE'));
                this.setState({ showDeleteConfirmModal: false });
                cleanFiltersHandler();
                refreshListHandler();
            })
            .onFail(error => Alert.error(error))
            .execute();
    };
}

DocumentaryLibraryTable.propTypes = {
    data: PropTypes.array,
    error: PropTypes.string,
    loading: PropTypes.bool,
    cleanFiltersHandler: PropTypes.func.isRequired,
    refreshListHandler: PropTypes.func.isRequired,
    canDelete: PropTypes.bool.isRequired,
};

DocumentaryLibraryTable.defaultProps = {
    data: [],
    error: '',
};



// WEBPACK FOOTER //
// ./src/app/documentary-library/list/DocumentaryLibraryTable.jsx